module.exports = __webpack_public_path__ + "static/media/main-bg.a78bff5f.jpg";